/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BankAccountViewModel } from './BankAccountViewModel';
import {
    BankAccountViewModelFromJSON,
    BankAccountViewModelFromJSONTyped,
    BankAccountViewModelToJSON,
} from './BankAccountViewModel';

/**
 * 
 * @export
 * @interface PaymentDetailsPaymentBankAccountViewModel
 */
export interface PaymentDetailsPaymentBankAccountViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsPaymentBankAccountViewModel
     */
    incomeBankAccountId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsPaymentBankAccountViewModel
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsPaymentBankAccountViewModel
     */
    bankAccountId: number;
    /**
     * 
     * @type {BankAccountViewModel}
     * @memberof PaymentDetailsPaymentBankAccountViewModel
     */
    bankAccount: BankAccountViewModel;
}

/**
 * Check if a given object implements the PaymentDetailsPaymentBankAccountViewModel interface.
 */
export function instanceOfPaymentDetailsPaymentBankAccountViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "bankAccountId" in value;
    isInstance = isInstance && "bankAccount" in value;

    return isInstance;
}

export function PaymentDetailsPaymentBankAccountViewModelFromJSON(json: any): PaymentDetailsPaymentBankAccountViewModel {
    return PaymentDetailsPaymentBankAccountViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsPaymentBankAccountViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsPaymentBankAccountViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'incomeBankAccountId': !exists(json, 'IncomeBankAccountId') ? undefined : json['IncomeBankAccountId'],
        'amount': json['Amount'],
        'bankAccountId': json['BankAccountId'],
        'bankAccount': BankAccountViewModelFromJSON(json['BankAccount']),
    };
}

export function PaymentDetailsPaymentBankAccountViewModelToJSON(value?: PaymentDetailsPaymentBankAccountViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IncomeBankAccountId': value.incomeBankAccountId,
        'Amount': value.amount,
        'BankAccountId': value.bankAccountId,
        'BankAccount': BankAccountViewModelToJSON(value.bankAccount),
    };
}

